//import update from 'immutability-helper';

const emptyState = {
  photo: ""
}

const DialogPhotoPreviewReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "DIALOGPHOTOPREVIEW_CHANGE_INPUT_VALUE" : {
      let { name, value } = action.payload;
      return {...state, [name]: value};
    }
    case "OPEN_OVERLAY": {
      let { dialog, params } = action.payload;
      if (dialog === "photo_preview") {
        let { photo="" } = params;
        return {...state, ...emptyState, photo };
      }

      // Empty everything if not selected
      return {};
    }
    case "CLOSE_OVERLAY": {
      // Empty everything if not selected
      return {};
    }
    default: {
      return state
    }
  }
}

export default DialogPhotoPreviewReducer